import React from 'react';
import { PodiumCard } from '../PodiumCard';
import { RankRow } from '../RankRow';
import styles from './TopSection.module.scss';

// Display order for the podium: 2nd (left), 1st (center/taller), 3rd (right)
const PODIUM_DISPLAY_ORDER = [2, 1, 3];

export const TopSection = ({ id, title, players = [], onViewAll, viewAllLabel, showCountryName }) => {
  const top3 = PODIUM_DISPLAY_ORDER.map((rank) =>
    players.find((p) => p.rank === rank),
  ).filter(Boolean);

  const rankList = players.filter((p) => p.rank >= 4 && p.rank <= 10);

  return (
    <section id={id} className={styles.section}>
      <h2 className={styles.title}>{title}</h2>

      <div className={styles.content}>
        {/* Podium – positions 1, 2, 3 */}
        <div className={styles.podium}>
          <div className={styles.podiumSlot2}>
            {top3.find((p) => p.rank === 2) && (
              <PodiumCard {...top3.find((p) => p.rank === 2)} />
            )}
          </div>
          <div className={styles.podiumSlot1}>
            {top3.find((p) => p.rank === 1) && (
              <PodiumCard {...top3.find((p) => p.rank === 1)} />
            )}
          </div>
          <div className={styles.podiumSlot3}>
            {top3.find((p) => p.rank === 3) && (
              <PodiumCard {...top3.find((p) => p.rank === 3)} />
            )}
          </div>
        </div>

        {/* Rank list – positions 4-10 */}
        <div className={styles.rankList}>
          {rankList.map((player) => (
            <RankRow key={player.rank} {...player} showCountryName={showCountryName} />
          ))}
          <button type="button" onClick={onViewAll} className={styles.viewAll}>
            {viewAllLabel}
          </button>
        </div>
      </div>
    </section>
  );
};
